import { executeProcedureCalculator } from '../../../../../services/exam';
import { CALCULATOR_TYPES, PROCEDURE_CODES } from './calculatorRegistry';
import { message } from "antd";
import moment from "moment";  

export const handleEstadoTestDeGrahamCalculation = async (value, admissionPatientId, form, procedures, user) => {
  if (!admissionPatientId) return;

  let deliveredTensResult = null;
  let deliveredDateResult = null;
  let deliveredTensResponse = null;
  let deliveredDateResponse = null;
  let receivingTensResult = null;
  let receivingDateResult = null;
  let receivingTensResponse = null;
  let receivingDateResponse = null;
  let deliveredToLaboratoryDateResult = null;
  let deliveredToLaboratoryDateResponse = null;
  let deliveredToLaboratoryTensResult = null;
  let deliveredToLaboratoryTensResponse = null;

  if (value) {
    try {
      deliveredTensResult = await executeProcedureCalculator({
        body: {
          procedureType: CALCULATOR_TYPES.PERSONA_QUE_ENTREGA_1_TEST_DE_GRAHAM,
          id: admissionPatientId,
          state: value,
        },
      });

      deliveredDateResult = await executeProcedureCalculator({
        body: {
          procedureType: CALCULATOR_TYPES.FECHA_QUE_ENTREGA_1_TEST_DE_GRAHAM,
          id: admissionPatientId,
          state: value,
        },
      });

      receivingTensResult = await executeProcedureCalculator({
        body: {
          procedureType: CALCULATOR_TYPES.PERSONA_QUE_RECIBE_1_TEST_DE_GRAHAM,
          id: admissionPatientId,
          state: value,
        },
      });

      receivingDateResult = await executeProcedureCalculator({
        body: {
          procedureType: CALCULATOR_TYPES.FECHA_DE_RECEPCION_1_TEST_DE_GRAHAM,
          id: admissionPatientId,
          state: value,
        },
      });

      deliveredToLaboratoryTensResult = await executeProcedureCalculator({
        body: {
          procedureType: CALCULATOR_TYPES.PERSONA_QUE_ENVIO_A_LABORATORIO_1_TEST_DE_GRAHAM,
          id: admissionPatientId,
          state: value,
        },
      });

      deliveredToLaboratoryDateResult = await executeProcedureCalculator({
        body: {
          procedureType: CALCULATOR_TYPES.FECHA_DE_ENVIO_A_LABORATORIO_1_TEST_DE_GRAHAM,
          id: admissionPatientId,
          state: value,
        },
      });
    } catch (error) {
      console.error('Error calculando Test de Graham::', error);
      message.error({
        content: 'Error calculando entrega de Test de Graham',
        style: {
          marginTop: '40vh',
        },
      });
      deliveredTensResult = null;
      deliveredDateResult = null;
      receivingTensResult = null;
      receivingDateResult = null;
      deliveredToLaboratoryTensResult = null;
      deliveredToLaboratoryDateResult = null;
    }
  }

  try {
    const deliveredTensProcedure = procedures.find((proc) => proc.code === PROCEDURE_CODES.PERSONA_QUE_ENTREGA_1_TEST_DE_GRAHAM);
    const deliveredDateProcedure = procedures.find((proc) => proc.code === PROCEDURE_CODES.FECHA_QUE_ENTREGA_1_TEST_DE_GRAHAM);
    const receivingTensProcedure = procedures.find((proc) => proc.code === PROCEDURE_CODES.PERSONA_QUE_RECIBE_1_TEST_DE_GRAHAM);
    const receivingDateProcedure = procedures.find((proc) => proc.code === PROCEDURE_CODES.FECHA_DE_RECEPCION_1_TEST_DE_GRAHAM);
    const deliveredToLaboratoryTensProcedure = procedures.find((proc) => proc.code === PROCEDURE_CODES.PERSONA_QUE_ENVIO_A_LABORATORIO_1_TEST_DE_GRAHAM);
    const deliveredToLaboratoryDateProcedure = procedures.find((proc) => proc.code === PROCEDURE_CODES.FECHA_DE_ENVIO_A_LABORATORIO_1_TEST_DE_GRAHAM);

   if (deliveredTensProcedure) {
       const currentValues = form.getFieldsValue();
       form.setFieldsValue({
         procedures: {
           ...currentValues.procedures,
           ...(deliveredTensResult != null && { [deliveredTensProcedure.id.toString()]: deliveredTensResult })
         }
       });
   
       if (deliveredTensResult) {
         deliveredTensResponse = {
           result: deliveredTensResult,
           calculatedFieldId: deliveredTensProcedure.id,
           calculatedFieldCode: deliveredTensProcedure.code,
         };
       }
     }
   
     if (deliveredDateProcedure) {
       const currentValues = form.getFieldsValue();
       const formattedDeliveredDate = deliveredDateResult ? moment(deliveredDateResult, 'DD-MM-YYYY') : null;
       form.setFieldsValue({
         procedures: {
           ...currentValues.procedures,
           ...(formattedDeliveredDate != null && { [deliveredDateProcedure?.id]: formattedDeliveredDate })
         }
       });
   
       if (deliveredDateResult) {
         deliveredDateResponse = {
           result: formattedDeliveredDate,
           calculatedFieldId: deliveredDateProcedure.id,
           calculatedFieldCode: deliveredDateProcedure.code,
         };
       }
     }
   
     if (receivingTensProcedure) {
       const currentValues = form.getFieldsValue();
       form.setFieldsValue({
         procedures: {
           ...currentValues.procedures,
           ...(receivingTensResult != null && { [receivingTensProcedure.id.toString()]: receivingTensResult })
         }
       });
   
       if (receivingTensResult) {
         receivingTensResponse = {
           result: receivingTensResult,
           calculatedFieldId: receivingTensProcedure.id,
           calculatedFieldCode: receivingTensProcedure.code,
         };
       }
     }
   
     if (receivingDateProcedure) {
       const currentValues = form.getFieldsValue();
       const formattedReceivingDate = receivingDateResult ? moment(receivingDateResult, 'DD-MM-YYYY') : null;
       form.setFieldsValue({
         procedures: {
           ...currentValues.procedures,
           ...(formattedReceivingDate != null && { [receivingDateProcedure?.id]: formattedReceivingDate })
         }
       });
   
       if (receivingDateResult) {
         receivingDateResponse = {
           result: formattedReceivingDate,
           calculatedFieldId: receivingDateProcedure.id,
           calculatedFieldCode: receivingDateProcedure.code,
         };
       }
     }
   
     if (deliveredToLaboratoryTensProcedure) {
       const currentValues = form.getFieldsValue();
       form.setFieldsValue({
         procedures: {
           ...currentValues.procedures,
           ...(deliveredToLaboratoryTensResult != null && { [deliveredToLaboratoryTensProcedure.id.toString()]: deliveredToLaboratoryTensResult })
         }
       });
   
       if (deliveredToLaboratoryTensResult) {
         deliveredToLaboratoryTensResponse = {
           result: deliveredToLaboratoryTensResult,
           calculatedFieldId: deliveredToLaboratoryTensProcedure.id,
           calculatedFieldCode: deliveredToLaboratoryTensProcedure.code,
         };
       }
     }
   
     if (deliveredToLaboratoryDateProcedure) {
       const currentValues = form.getFieldsValue();
       const formattedDeliveredToLaboratoryDate = deliveredToLaboratoryDateResult ? moment(deliveredToLaboratoryDateResult, 'DD-MM-YYYY') : null;
       form.setFieldsValue({
         procedures: {
           ...currentValues.procedures,
           ...(formattedDeliveredToLaboratoryDate != null && { [deliveredToLaboratoryDateProcedure?.id]: formattedDeliveredToLaboratoryDate }),
         },
       });
   
       if (deliveredToLaboratoryDateResult) {
         deliveredToLaboratoryDateResponse = {
           result: formattedDeliveredToLaboratoryDate,
           calculatedFieldId: deliveredToLaboratoryDateProcedure.id,
           calculatedFieldCode: deliveredToLaboratoryDateProcedure.code,
         };
       }
     }
   
     return [
       deliveredTensResponse,
       deliveredDateResponse,
       receivingTensResponse,
       receivingDateResponse,
       deliveredToLaboratoryTensResponse,
       deliveredToLaboratoryDateResponse,
     ];
  } catch (error) {
    console.error('Error calculating estadoTestDeGraham:', error);
    return [null, null, null, null, null, null];
  }
};
